// extracted by mini-css-extract-plugin
export default {"visible":"style_visible__ygi--","hidden":"style_hidden__25PAe","view-more":"style_view-more__t-J-j","view-more__array-icon":"style_view-more__array-icon__EBw7q"};